import styled from 'styled-components';

export const TransactionFailureInfoContainer = styled.div`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: end;
  gap: 0.25rem;
`;
